import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2 className='text-center text-black fs-1 font-weight-bold'>Mechanic is Sleeping !</h2>
        </div>
    );
};

export default NotFound;